module.exports = __webpack_public_path__ + "img/check.2943527b.svg";